var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.63px",
    height: "57.79px",
    viewBox: "0 0 64.63 57.79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-773.930000, -3569.660000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-0.060000, -1.890000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.34,3620.34 L779.34,3629.34 L773.99,3623.99 L780.25,3617.73 L780.25,3617.72 L792.4,3605.57 C791.260027,3603.55707 790.660581,3601.28331 790.66,3598.97 L790.66,3584.9 C790.66305,3581.36386 792.073536,3577.97438 794.58,3575.48 L794.59,3575.46 C797.088076,3572.96028 800.476025,3571.55403 804.01,3571.55 L805.29,3571.55 L805.29,3579.11 L804.01,3579.11 C802.476325,3579.10779 801.004781,3579.71583 799.92,3580.8 L799.91,3580.81 C798.828752,3581.89592 798.224253,3583.36759 798.23,3584.9 L798.23,3598.97 C798.228342,3602.16451 800.815491,3604.75614 804.01,3604.76 L818.09,3604.76 C819.625503,3604.76267 821.098738,3604.15319 822.183566,3603.06649 C823.268393,3601.97978 823.875325,3600.5055 823.87,3598.97 L823.87,3592.55 L831.43001,3592.55 L831.43001,3598.97 C831.434357,3602.50565 830.026825,3605.89668 827.52,3608.39 L827.5,3608.41 C825.006804,3610.9109 821.621364,3612.3176 818.09,3612.32 L804.01,3612.32 C801.865871,3612.32304 799.752691,3611.80847 797.85,3610.82 L788.34,3620.33 L788.34,3620.34 L788.34,3620.34 Z M809.07,3582.05 L838.62,3582.05 L838.62,3589.62 L809.07,3589.62 L809.07,3582.05 Z",
    id: "Path_45"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.657718e564050ee954eba48b5cbee72d.svg";
export { ForwardRef as ReactComponent };